import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from "@auth0/angular-jwt";

const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  permissions; // Store the actions for which this user has permission
  userRole: string
  roles: any[];

  constructor(private httpClient: HttpClient) { }

  hasPermission(functionality: string): boolean {
    if (this.permissions) {
      // console.log("Current permission check for : " + functionality)
      // console.log("IN HAS PERMISSION ------------- " + (this.permissions.indexOf(functionality) > -1));
      let _token: string = localStorage.getItem('accessToken')
      const decodedToken = helper.decodeToken(_token);
      const role = decodedToken.role;
      let _permissions = this.permissions.map(x => x.permission);
      let _permissionDetail = this.permissions.find(x => x.permission == functionality)
      let _roles = _permissionDetail.roles;
      // console.log(_roles);
      // console.log(`curretnt role : ${role}`);
      // console.log(`has pemission : ${((_permissions.indexOf(functionality) > -1) && (_roles.indexOf(role) > -1))}`);
      return ((_permissions.indexOf(functionality) > -1) && (_roles.indexOf(role) > -1))
      //  this.permissions.find((func) => func === functionality);
    }
    return false;
  }

  // This method is called once and a list of permissions is stored in the permissions property
  initializePermissions() {
    const cacheBusterParam = (new Date()).getTime();
    const jsonFile = `assets/permissions.json`;
    return new Promise<void>((resolve, reject) => {
      this.httpClient.get(jsonFile).toPromise()
        .then((response: any) => {
          // this.roles = response.roles.map(function (el) { return el.roles; })
          this.permissions = response.permissions;
          // console.log(this.permissions)
          resolve();
        }).catch((response: any) => {
          reject(`Could not load Permissions..  : ${JSON.stringify(response)}`);
        });
    });

    this.permissions = ['Add Retailer', 'Fund Postpaid Retailer Credit Line', 'Setup auto reload for Postpaid Retailer',
      'Manage Retailer'];
    return this.permissions

  }
}
